import type { IPhotoItem } from "~/interfaces";
import { ALL_LANGS, ROUTES } from "~/const";
import { mainStore } from "~/stores/main";

export function getDefaultLang() {
	const paths = location.pathname.split("/").filter(item => item);
	/* eslint-disable-next-line */
	const browserLang = navigator.languages.map(item => item.slice(0, 2))[0];
	const usp = new URLSearchParams(location.search);
	const searchLang = usp.get("lang");
	let lang = ALL_LANGS[0];

	// nejdrive path | url search | browser | default
	if (paths.length && ALL_LANGS.includes(paths[0])) {
		lang = paths[0];
	} else if (searchLang && ALL_LANGS.includes(searchLang)) {
		lang = searchLang;
	} else if (browserLang && ALL_LANGS.includes(browserLang)) {
		lang = browserLang;
	}

	return lang;
}

export function trans(key: string): string {
	const parts = key.split(".");
	const len = parts.length;
	const mainStoreData = mainStore.getState().data;
	let output = key;
	let source = mainStoreData.trans;

	for (let ind = 0, max = parts.length; ind < max; ind++) {
		const part = parts[ind];

		if (part in source) {
			source = source[part];
		}

		if (ind === len - 1 && mainStoreData.lang in source) {
			output = source[mainStoreData.lang];
		} else if (ind === len - 1 && ALL_LANGS[0] in source) {
			output = source[ALL_LANGS[0]];
		}
	}

	return output;
}

export function overrideLang(newLang: string) {
	mainStore.getState().setLang(newLang);
}

export function getLink(langObj: {[key: string]: string}) {
	const curLang = mainStore.getState().data.lang;

	return `/${curLang}/${langObj[curLang]}`;
}

export function setLang(newLang: string) {
	if (ALL_LANGS.indexOf(newLang) === -1) {
		return;
	}

	const curLang = mainStore.getState().data.lang;

	if (curLang !== newLang) {
		// zmena url
		const routeEntries = Object.entries(ROUTES);
		const parts = location.pathname.split("/");
		const lastPart = parts[parts.length - 1];
		let newUrl = "";

		for (const entry of routeEntries) {
			const allLangs = Object.values(entry[1]);

			if (allLangs.includes(lastPart)) {
				overrideLang(newLang);
				newUrl = getLink(entry[1]);
				break;
			}
		}

		if (newUrl) {
			location.href = newUrl;
		}
	}
}

export function getPhotoDesc(photoItem: IPhotoItem): string {
	const curLang = mainStore.getState().data.lang;

	if ("uni" in photoItem) {
		return photoItem.uni || "";
	} else if (curLang in photoItem) {
		return photoItem[curLang] || "";
	}

	return "";
}

export function setSeo() {
	const html = document.querySelector("html");
	const keywords = document.querySelector("meta[name='keywords']");
	const description = document.querySelector("meta[name='description']");
	const ogTitle = document.querySelector("meta[property='og:title']");
	const ogLocale = document.querySelector("meta[property='og:locale']");
	const ogDescription = document.querySelector("meta[property='og:description']");

	document.title = trans("seo.title");
	ogTitle?.setAttribute("content", trans("seo.title"));
	html.lang = trans("seo.localeShort");
	keywords?.setAttribute("content", trans("seo.keywords"));
	description?.setAttribute("content", trans("seo.description"));
	ogLocale?.setAttribute("content", trans("seo.localeLong"));
	ogDescription?.setAttribute("content", trans("seo.description"));
}
